<template>
  <div
    class="search-input-container"
  >
    <div class="bottom-padding">
      {{ $t('topText') }}
    </div>
    <div class="columns input-container is-3">
      <div
        class="text-div column"
        :class="focusedField === 'Name' ? 'fade' : ''"
      >
        <validation-observer
          ref="search-by-PID"
          tag="form"
          class="form"
          mode="passive"
          @submit.prevent="submitPIDForm"
        >
          <div class="column border">
            <div class="space-between-container">
              <div class="box-text">
                {{ $t('pidInput') }}
              </div>
              <textbox-with-validation
                v-model.trim="searchData.PID"
                rules="required|max:7|numeric"
                :placeholder="$t('placeholder.Placeholder_PID')"
                :disabled="focusedField == 'Name'"
              />
            </div>
          </div>
          <div class="field">
            <div class="control button-field">
              <button
                :disabled="focusedField !== 'PID'"
                class="button custom"
                type="submit"
              >
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </validation-observer>
      </div>
      <div
        class="text-div column is-1 center-text"
        :class="(focusedField === 'Name' || focusedField === 'PID') ? 'fade' : ''"
      >
        <div class="or">
          <b> {{ $t('or') }} </b>
        </div>
      </div>
      <div
        class="column is-8 test-class-replace-2"
        :class="focusedField === 'PID' ? 'fade' : ''"
      >
        <validation-observer
          ref="search-by-name"
          tag="form"
          class="form"
          @submit.prevent="submitNameForm"
        >
          <div class="column border">
            <div class="space-between-container">
              <div class="box-text">
                {{ $t('nameInput') }}
              </div>
              <div class="text-div text-flex">
                <textbox-with-validation
                  v-model="searchData.FirstName"
                  rules="required"
                  mode="passive"
                  :placeholder="$t('placeholder.Placeholder_First')"
                  :disabled="focusedField == 'PID'"
                />
                <textbox-with-validation
                  v-model="searchData.LastName"
                  rules="required"
                  mode="passive"
                  :placeholder="$t('placeholder.Placeholder_Last')"
                  :disabled="focusedField == 'PID'"
                />
                <textbox-with-validation
                  v-model="searchData.birthdate"
                  rules="required|date"
                  mode="passive"
                  :placeholder="$t('placeholder.Placeholder_DOB')"
                  :disabled="focusedField == 'PID'"
                />
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control button-field">
              <button
                class="button custom"
                :disabled="focusedField !== 'Name'"
              >
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import TextboxWithValidation from '@/components/TextboxWithValidation';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'SearchForm',
  components: {
    TextboxWithValidation,
  },
  props: {
    focusedField: {
      type: [ Boolean, String ],
      default: false,
    },
    focusedClass: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapFields(
      'searchData.PID',
      'searchData.FirstName',
      'searchData.LastName',
      'searchData.birthdate',
    ),
  },
  methods: {
    async submitPIDForm() {
      const isValid = await this.$refs['search-by-PID'].validate();
      if (!isValid) {
        return false;
      }
      // this.$emit('searchData', this.searchData);

      const response = await this.$store.dispatch('getDataByPID', this.searchData.PID);
      this.$refs['search-by-PID'].reset();
      this.routeAfterSearch(response);
    },
    async submitNameForm() {
      const isValid = await this.$refs['search-by-name'].validate();
      if (!isValid) {
        return false;
      }
      // this.$emit('searchData', this.searchData);

      this.$store.commit("setDisplay", "error");
      const response = await this.$store.dispatch('getDataByName', this.searchData);
      this.$refs['search-by-name'].reset();
      this.routeAfterSearch(response);
    },

    routeAfterSearch(response) {
      if (response === true) {
        this.$router.push('/results');
      } else if (response === false) {
        this.$router.push('/error');
      } else if (response instanceof Error) {
        this.$router.push('/system-down');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.space-between-container {
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-content: stretch;
  justify-content: space-between;
  height: 90px;
  @include until($tablet) {
    height: auto;
  }
}
.button-field {
  display: flex;
  margin: 1rem 0;
  .button.custom {
    margin-left: auto;
  }
}

</style>
